import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFeather, FiHexagon, FiSun, FiShoppingBag } = FiIcons;

const features = [
  [FiFeather, 'Timeless Design', 'Elegance that never goes out of style.'],
  [FiHexagon, 'Curated Collections', 'Thoughtfully selected sarees for every occasion.'],
  [FiSun, 'Premium Quality', 'Details chosen with care and attention.'],
  [FiShoppingBag, 'Effortless Ordering', 'Choose your ZEVI and complete checkout through our secure online store.']
];

function Experience() {
  return (
    <section className="experience section">
      <header className="section-heading compact">
        <h2>The ZEVI Experience</h2>
      </header>
      <div className="feature-grid">
        {features.map(([icon, title, description]) => (
          <article className="feature" key={title}>
            <SafeIcon icon={icon} />
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Experience;